/*
 * AQS — basketball "swish" to cart. The ball only fires when an item is
 * ACTUALLY added to the cart (the cart count goes up), not on button click.
 * It arcs from the most-recently-clicked add button into the header cart icon,
 * which then pops. On-brand (basketball DNA), respects prefers-reduced-motion.
 */
(function () {
  if (window.__aqsBball) return;
  window.__aqsBball = true;

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var lastTrigger = null; // { el, t }
  var cooldownUntil = 0;

  // Remember where an add was triggered from (so the ball arcs from there).
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest(
        '.add-to-cart-button, button[name="add"], .sticky-add-to-cart__button, .aqs-cart-upsell__addbtn, add-to-cart-component button'
      );
      if (btn) lastTrigger = { el: btn, t: Date.now() };
    },
    true
  );

  function cartIcon() {
    return (
      document.querySelector('.header-actions__cart-icon') ||
      document.querySelector('[aria-controls="cart-drawer"]')
    );
  }

  function cartCount() {
    var el = document.querySelector(
      '.cart-bubble__text-count, cart-icon .cart-bubble__text, [data-testid="cart-count"]'
    );
    if (!el) return 0;
    var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  var prevCount = cartCount();

  function onCartChange() {
    var now = cartCount();
    if (now > prevCount && Date.now() > cooldownUntil) {
      cooldownUntil = Date.now() + 500;
      fire();
    }
    prevCount = now;
  }

  function fire() {
    var to = cartIcon();
    if (!to) return;
    if (reduce) {
      pop(to);
      return;
    }
    var from =
      lastTrigger &&
      Date.now() - lastTrigger.t < 6000 &&
      document.body.contains(lastTrigger.el)
        ? lastTrigger.el
        : to;
    shoot(from, to);
  }

  // Watch the whole header region for the cart count changing (robust against
  // Shopify re-rendering the cart icon on add).
  function observe() {
    var host =
      document.querySelector('#header-component') ||
      document.querySelector('header-actions') ||
      document.body;
    var obs = new MutationObserver(onCartChange);
    obs.observe(host, { childList: true, subtree: true, characterData: true });
    // Also catch Shopify's cart events if the theme dispatches them.
    document.addEventListener('cart:refresh', onCartChange);
    document.addEventListener('cart:updated', onCartChange);
    document.addEventListener('variant:add', onCartChange);
  }

  if (document.readyState !== 'loading') observe();
  else document.addEventListener('DOMContentLoaded', observe);

  function shoot(fromEl, toEl) {
    var a = fromEl.getBoundingClientRect();
    var b = toEl.getBoundingClientRect();
    var startX = a.left + a.width / 2;
    var startY = a.top + a.height / 2;
    var endX = b.left + b.width / 2;
    var endY = b.top + b.height / 2;

    var ball = document.createElement('span');
    ball.textContent = '🏀';
    ball.setAttribute('aria-hidden', 'true');
    ball.style.cssText =
      'position:fixed;left:0;top:0;z-index:99999;font-size:52px;line-height:1;' +
      'pointer-events:none;will-change:transform,opacity;filter:drop-shadow(0 8px 12px rgba(0,0,0,.28));';
    document.body.appendChild(ball);

    var dur = 950;
    var start = performance.now();
    var arc = Math.min(220, Math.max(110, Math.abs(startY - endY) * 0.5 + 130));

    function frame(now) {
      var t = Math.min(1, (now - start) / dur);
      var ease = 1 - Math.pow(1 - t, 2);
      var x = startX + (endX - startX) * ease;
      var y = startY + (endY - startY) * ease - Math.sin(Math.PI * t) * arc;
      var scale = 1 - 0.55 * t;
      var rot = t * 620;
      ball.style.transform =
        'translate(' + (x - 26) + 'px,' + (y - 26) + 'px) scale(' + scale + ') rotate(' + rot + 'deg)';
      ball.style.opacity = t > 0.85 ? String((1 - t) / 0.15) : '1';
      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        dropThrough(ball, endX, endY);
        pop(toEl);
      }
    }
    requestAnimationFrame(frame);
  }

  // Ball drops through the net with a little bounce, then fades.
  function dropThrough(ball, x, y) {
    var start = performance.now();
    var dur = 380;
    function f(now) {
      var t = Math.min(1, (now - start) / dur);
      var drop = 28 * easeOutBounce(t);
      var scale = 0.45 * (1 - t * 0.7);
      ball.style.transform =
        'translate(' + (x - 26) + 'px,' + (y - 26 + drop) + 'px) scale(' + Math.max(0.08, scale) + ') rotate(' + (620 + t * 160) + 'deg)';
      ball.style.opacity = String(1 - t * t);
      if (t < 1) requestAnimationFrame(f);
      else ball.remove();
    }
    requestAnimationFrame(f);
  }

  function easeOutBounce(t) {
    var n1 = 7.5625;
    var d1 = 2.75;
    if (t < 1 / d1) return n1 * t * t;
    if (t < 2 / d1) { t -= 1.5 / d1; return n1 * t * t + 0.75; }
    if (t < 2.5 / d1) { t -= 2.25 / d1; return n1 * t * t + 0.9375; }
    t -= 2.625 / d1;
    return n1 * t * t + 0.984375;
  }

  // Hoop pops with a springy bounce.
  function pop(el) {
    el.style.transition = 'transform .16s cubic-bezier(.34,1.56,.64,1)';
    el.style.transform = 'scale(1.4)';
    setTimeout(function () {
      el.style.transform = 'scale(0.9)';
      setTimeout(function () {
        el.style.transform = 'scale(1)';
        setTimeout(function () {
          el.style.transition = '';
          el.style.transform = '';
        }, 150);
      }, 120);
    }, 150);
  }
})();
